exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-div[data-v-3b5eb8f4]{text-align:center;width:100%;margin-bottom:30px\n}", ""]);

// exports
